import type { ReactElement } from "react";
import { GroupedTableHeaderCellProps } from "./GroupedTableHeaderCell.types";
import { SmallBody } from "src/components/Text";
import { GroupedTableEmbeddedToolbar } from "../GroupedTableEmbeddedToolbar";
import { GroupedTableSortButton } from "../GroupedTableSortButton";

/**
 * GroupedTableHeaderCell component
 *
 * @param {GroupedTableHeaderCellProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function GroupedTableHeaderCell<TItemType>({
    column,
    renderToolbar,
}: GroupedTableHeaderCellProps<TItemType>): ReactElement | null {
    return (
        <div className="GroupedTableHeaderCell">
            <SmallBody className="GroupedTableHeaderCell-Text"
                       color="contentDark">
                {column.header}
            </SmallBody>
            <div className="buttons">
                {renderToolbar && (
                    <div className="embedded-toolbar">
                        <GroupedTableEmbeddedToolbar />
                    </div>
                )}
                {column.sortable && (
                    <GroupedTableSortButton />
                )}
            </div>
        </div>
    );
}

export default GroupedTableHeaderCell;

